import dayjs from "@/lib/helpers/dayjs";

import type { EncounterInitialValues } from "../helpers/encounter-schema";

export const ENCOUNTER_INITIAL_VALUES: EncounterInitialValues = {
  delete_marker: false,
  discharge_date: "",
  discharge_type: [],
  encounter_date: dayjs().format("MM/DD/YYYY"),
  encounter_information: "",
  encounter_type: [],
  setting: [],
  setting_other: "",
};
